<template>
  <div
    class="z-50 mb-2 flex w-full items-center justify-between rounded-lg border p-2 shadow-lg backdrop-blur"
    :class="{
      'border-primary-50 bg-primary-100/60 text-primary-900 dark:border-primary-dark-700 dark:bg-primary-dark-800/70 dark:text-primary-dark-100':
        alert.alertType === AlertTypes.Info,
      'border-green-100 bg-green-100/60 text-green-900 dark:border-green-700 dark:bg-green-800/70 dark:text-green-200':
        alert.alertType === AlertTypes.Success,
      'border-yellow-100 bg-yellow-100/60 text-yellow-900 dark:border-yellow-700 dark:bg-yellow-800/70 dark:text-yellow-200':
        alert.alertType === AlertTypes.Warning,
      'border-red-100 bg-yapred-50/60 text-yapred-800 dark:border-yapred-700 dark:bg-yapred-900/70 dark:text-yapred-100':
        alert.alertType === AlertTypes.Error
    }"
  >
    <div class="overflow-hidden">
      <strong v-if="alert.title">{{ $t(alert.title) }}</strong>
      <p class="overflow-x-auto">{{ $t(alert.message) }}</p>
    </div>
    <YapButtonIcon
      class="rounded-full"
      :class="{
        'text-primary-900 dark:text-primary-dark-100': alert.alertType === AlertTypes.Info,
        'text-green-900 dark:text-green-200': alert.alertType === AlertTypes.Success,
        'text-yellow-900 hover:bg-yellow-300/50 dark:text-yellow-200 dark:hover:bg-yellow-800/70':
          alert.alertType === AlertTypes.Warning,
        'text-yapred-900 hover:bg-yapred-100/70 dark:text-yapred-100 dark:hover:bg-yapred-900/70':
          alert.alertType === AlertTypes.Error
      }"
      @click="handleDismissed(alert.id)"
      v-if="alert.dismissable || !!alert.autoDismissDelay"
    >
      <YapIcon name="close-outline" class="h-6 w-6" />
    </YapButtonIcon>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

import YapIcon from '@/components/YapIcon.vue';
import YapButtonIcon from '@/components/YapButtonIcon.vue';
import { useAlertStore, Alert, AlertTypes } from '@/store/alertsStore';

const props = defineProps<{
  alert: Alert;
}>();

const alertStore = useAlertStore();

function handleDismissed(id: string) {
  alertStore.removeAlert(id);
}

onMounted(() => {
  if (!!props.alert.autoDismissDelay) {
    setTimeout(() => {
      handleDismissed(props.alert.id);
    }, props.alert.autoDismissDelay);
  }
});
</script>
